import { render } from "./TradePairToggle.vue?vue&type=template&id=60abc857&scoped=true&ts=true"
import script from "./TradePairToggle.vue?vue&type=script&lang=ts"
export * from "./TradePairToggle.vue?vue&type=script&lang=ts"

import "./TradePairToggle.vue?vue&type=style&index=0&id=60abc857&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60abc857"]])

export default __exports__